<template>
  <div class="ownerDetail">
    <div class="share" @click="handleShare">
      <van-icon name="ellipsis" size="0.5rem"/>
    </div>
    <div class="top">
      <div>
        {{dataDetail.name}}
        <van-icon v-show="checked==1" name="edit" size="0.4rem" @click="toUpdate" />
      </div>
      <div>{{dataDetail.mobile}}</div>
    </div>

    <div class="list">
      <van-cell center title="货主状态" style="margin-bottom:0.1rem">
        <template #right-icon>
          <van-switch
            v-model="checked"
            active-value="1"
            inactive-value="2"
            size="24"
            :loading="loading"
            active-color="#31B158"
            @change="handleChange"
          />
        </template>
      </van-cell>
      <div class="title">
        <span>进货明细</span>
        <span v-if="dataDetail.goods&&dataDetail.goods.length>0">
          共
          <strong>{{dataDetail.goods.length}}</strong> 批
        </span>
      </div>
      <div class="batch_list" v-if="dataDetail.goods&&dataDetail.goods.length>0">
        <van-cell
          v-for="(item,index) in dataDetail.goods"
          :key="index"
          :title="item.name"
          :label="'批次号：'+item.batch"
          :value="timestampToTime(item.create_time)"
        />
      </div>
      <div v-else>
        <van-cell title="暂无" />
      </div>
    </div>
  </div>
</template>

<script>
import { owner_detail, owner_delete } from "@/api/work/manage/owner";
import { timestampToTime } from "@/utils/timestamp";
export default {
  name: "ownerDetail",
  data() {
    return {
      id: "",//货主
      dataDetail: {},
      checked: "2",
      loading: false
    };
  },
  filters: {
    toTime(t) {
      return timestampToTime(t);
    }
  },
  created() {
    this.id = this.$route.query.id;
    this.getData();
    this.$navigation.on("back", (to, from) => {
      if (from.route.name == "manage_owner_addOwner") {
        this.getData();
      }
    });
  },
  mounted() {},
  methods: {
    // 获取数据
    getData() {
      owner_detail({ id: this.id }).then(res => {
        if (res.code == 200) {
          this.dataDetail = res.data;
          this.checked = res.data.status + "";
        }
      });
    },
    timestampToTime,
    //
    toUpdate() {
      this.$router.push({
        path: "/manage/owner/addOwner",
        query: {
          id: this.$route.query.id,
        
        }
      });
    },

    // 修改状态
    handleChange(status) {
      this.loading = true;
      owner_delete({ id: this.dataDetail.id, status }).then(res => {
        if (res.code == 200) {
          this.loading = false;
          this.getData();
          // this.$toast.success(res.message);
        }
      });
    },

    // 分享
    handleShare(){
      console.log(this.dataDetail)
        var weixin;
        // 获取到 mid 经营户编号 sid 供应商编号
        // 前缀+'ownerShare.html?mid=2&sid=2'
        let mid=this.dataDetail.mid
        let sid=this.dataDetail.id
        let url=`${process.env.VUE_APP_SHARE_SUPPLIER_URL}ownerShare.html?mid=${mid}&sid=${sid}`
        console.log(url)
        var data={
          title:"货主",
          thumbs:"",
          content:"分享内容说明",
          href:url,//
          extra:{scene:"WXSceneSession"}
        };
        console.log(data);
        if(window.plus){
            plus.share.getServices(function(s){
            weixin=s[0]
            weixin.send(data)
            }, function(e){
              alert("获取分享服务列表失败： "+JSON.stringify(e));
            });
        }
    }
  }
};
</script>

<style lang="less" scoped>
.ownerDetail {
  .share{
    position: fixed;
    right: 0rem;
    padding: 0 0.3rem;
    height: 0.88rem;
    top: 0;
    z-index: 99;
    display: flex;
    align-items: center;
  }
  .top {
    width: 100%;
    height: 2.74rem;
    background: url("../../../../assets/img/work/manage/buyerDetail_bg.png")
      no-repeat center;
    background-size: 100% 100%;
    color: #fff;
    padding-left: 0.31rem;
    box-sizing: border-box;
    overflow: hidden;
    .van-icon {
      margin-left: 0.58rem;
      vertical-align: sub;
      font-weight: 600;
    }
    > div:first-child {
      margin-top: 0.7rem;
      margin-bottom: 0.29rem;
      font-size: 0.36rem;
    }
    > div:last-child {
      font-size: 0.24rem;
    }
  }
  .list {
    margin-top: -0.5rem;
    .title {
      padding: 0 0.3rem;
      background-color: #fff;
      line-height: 0.88rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 0.3rem;
      border-bottom: 0.01rem solid #f1f1f1;
    }
  }
  .center {
    width: 6.9rem;
    margin: -0.77rem auto 0.2rem;
    border-radius: 0.16rem;
    background-color: #fff;
    padding: 0.2rem 0;
    display: flex;
    align-items: center;
    box-shadow: 0 0 0.2rem #dde6ff;
    > div {
      box-sizing: border-box;
      display: inline-block;
      width: 33.3%;
      text-align: center;
      color: #4e4e4e;
      > div:first-child {
        font-size: 0.4rem;
        color: #333333;
      }
      > div:last-child {
        color: #999999;
      }
    }
    > div:not(:last-child) {
      border-right: 0.01rem solid #e6e6e6;
    }
  }
}
</style>